export const assignPolicyMenuItemName = "tbb";
export default {assignPolicyMenuItemName};